import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { DASHBOARD_SECTIONS } from '@shared/constants/business/lite';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { DASHBOARD_SECTION_ROUTES } from './dashboard-routes';
import { useIsDashboardsEnabled } from './hooks';

export const Route = createFileRoute('/console/$orgId/dashboard/')({
    component: DashboardHome,
});

function DashboardHome() {
    const orgId = useOrgId();
    const navigate = useNavigate();
    const isDashboardsEnabled = useIsDashboardsEnabled();

    // Land on the first enabled section in tab order. Curium Lite's allow-list is already applied
    // by `useIsDashboardsEnabled`, so a Lite org lands on Complaints.
    const section = DASHBOARD_SECTIONS.find((key) => isDashboardsEnabled[key]);

    // Keep navigate in a ref so this redirect effect only reacts to the target route.
    const navigateRef = useRef(navigate);
    navigateRef.current = navigate;

    useEffect(() => {
        if (section) {
            navigateRef.current({
                to: DASHBOARD_SECTION_ROUTES[section],
                params: { orgId },
                replace: true,
            });
        } else {
            navigateRef.current({ to: '/console/$orgId', params: { orgId }, replace: true });
        }
    }, [orgId, section]);

    return null;
}
